/**
 * 파워북
 */
import { useMemo, Fragment, type ReactNode } from 'react';
import type { IPowerbook } from '@type/index';

const UrlComponent = ({ url, children }: { url: string | null, children: ReactNode }) => {
  if (!url) {
    return <Fragment>{children}</Fragment>;
  }

  return <a href={url}>{children}</a>;
};

const PowerbookArticle = ({ item }: { item: IPowerbook }) => {
  if (!item) {
    return <Fragment />;
  }

  const { thumbnail, keyword, contents } = item;
  const url = useMemo(() => {
    if (!keyword) return null;
    const encodedKeyword = encodeURIComponent(keyword.replace(/<[^>]*>/g, ''));
    return `/powerbook/wiki?keyword=${encodedKeyword}`;
  }, [keyword]);
  return (
    <div className="search-item-content">
      {thumbnail ? (
        <div className="search-item-thumbnail">
          <UrlComponent url={url}>
            <img src={thumbnail} alt="" />
          </UrlComponent>
        </div>
      ) : (
        <Fragment />
      )}
      <div className="search-item-article">
        <UrlComponent url={url}>
          <div className="search-item-title" dangerouslySetInnerHTML={{ __html: keyword }}></div>
          <div className="search-item-summary" dangerouslySetInnerHTML={{ __html: contents }}></div>
        </UrlComponent>
      </div>
    </div>
  );
};

export default PowerbookArticle;
